import { ApiResult } from 'interfaces/APITypes';

import { makeRequest, mytoverInstance } from './client';

export const getReports = async (options?: any): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/reports', { params: options }));
};
